import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

export default function CreatePoolModal({ isOpen, onClose, onCreated }) {
  const baseUrl = getHostDomain();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [strategy, setStrategy] = useState("round_robin");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  function reset() {
    setName("");
    setDescription("");
    setStrategy("round_robin");
    setError(null);
  }

  async function handleSubmit() {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetchController(
        `${baseUrl}/api/v1/calendar_pool`,
        "POST",
        {
          name: name.trim(),
          description: description.trim() || null,
          strategy,
          last_index: 0,
          settings: {},
        }
      );
      const created = res?.data;
      reset();
      if (created) onCreated?.(created);
    } catch (e) {
      setError(e?.message || "Failed to create pool");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => { reset(); onClose(); }}
      size="md"
      closeOnOverlayClick={!submitting}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>New Calendar Pool</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              <FormControl isInvalid={!!error && !name.trim()} isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  placeholder="e.g. Sales Setters"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoFocus
                />
                {!!error && !name.trim() && (
                  <FormErrorMessage>{error}</FormErrorMessage>
                )}
              </FormControl>

              <FormControl>
                <FormLabel>Strategy</FormLabel>
                <Select value={strategy} onChange={(e) => setStrategy(e.target.value)}>
                  <option value="round_robin">Round Robin — rotate through members</option>
                  <option value="priority">Priority — try by priority order</option>
                  <option value="least_busy">Least Busy — prefer least-loaded</option>
                </Select>
                <FormHelperText>You can change this later.</FormHelperText>
              </FormControl>

              <FormControl>
                <FormLabel>Description</FormLabel>
                <Textarea
                  placeholder="Optional — what this pool is for"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={3}
                />
              </FormControl>

              {!!error && name.trim() && (
                <FormControl isInvalid>
                  <FormErrorMessage>{error}</FormErrorMessage>
                </FormControl>
              )}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={() => { reset(); onClose(); }} isDisabled={submitting}>
              Cancel
            </Button>
            <Button
              type="button"
              colorScheme="blue"
              isLoading={submitting}
              onClick={handleSubmit}
            >
              Create Pool
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
